import React, { createContext, ReactNode, useEffect, useState } from 'react'
import { logEvent, setUserId, setUserProperties } from 'firebase/analytics'
import { analytics } from '~/firebase-analytics'
import { User } from '~/interfaces'
import { AxiosConfig } from '~/modules'

interface LoggedInUserProviderProps {
  children: ReactNode
  sessionData?: User
}

const defaultValue = {
  user: {} as User
}

export interface LoggedInUserContextProps {
  user?: User
}

const LoggedInUserContext = createContext<LoggedInUserContextProps>({ ...defaultValue } as LoggedInUserContextProps)

const LoggedInUserProvider: React.FC<LoggedInUserProviderProps> = ({
  children,
  sessionData
}: LoggedInUserProviderProps) => {
  const [user, setUser] = useState<User>()

  const sendUserMetricEvents = (user: User) => {
    // const userMainSpecialty = user?.health_professional_data?.specialties[0]?.description || 'unknown'
    const userName = user.objeto[0].NomeUsuario || 'unknown'

    setUserId(analytics, String(user.objeto[0].CodLogin))
    // setUserProperties(analytics, { specialties: userMainSpecialty, name: userName })
    setUserProperties(analytics, { name: userName })
    logEvent(analytics, 'userName', { userName })
  }

  useEffect(() => {
    if (sessionData) {
      setUser(sessionData)
      sendUserMetricEvents(sessionData)
      AxiosConfig.setAxiosAuth(sessionData?.access_token)
    }
  }, [sessionData])

  return (
    <LoggedInUserContext.Provider
      value={{
        user
      }}
    >
      {children}
    </LoggedInUserContext.Provider>
  )
}

const useLoggedInUser = (): LoggedInUserContextProps => {
  return React.useContext(LoggedInUserContext)
}

export { LoggedInUserContext, LoggedInUserProvider, useLoggedInUser }
